/**
 * Términos PÚBLICOS del programa de referidos para los copys dinámicos del
 * cliente (02-06). Única fuente: `GET /api/referral/program`, que lee los
 * mismos accessors de env que usa el cron al acreditar — así el copy nunca
 * promete algo distinto de lo que el servidor concede. Sin PII ni secretos.
 */
export interface ReferralProgramTerms {
  /** Minutos M que gana el referidor con la primera compra del invitado. */
  referrerMinutes: number
  /** Minutos P extra que gana el invitado en su primera compra (≠ bonus signup). */
  refereePurchaseMinutes: number
  /** Días de holdback entre la compra y la acreditación. */
  holdbackDays: number
}

/**
 * Master-flag público del programa (default OFF): decide si CUALQUIER superficie
 * de referidos se muestra. Compartida por la tarjeta del dashboard y el CTA del
 * paywall para que no puedan divergir.
 */
export function isReferralEnabled(): boolean {
  return process.env.NEXT_PUBLIC_REFERRAL_ENABLED === 'true'
}

export async function fetchReferralProgramTerms(): Promise<ReferralProgramTerms | null> {
  try {
    const response = await fetch('/api/referral/program')
    if (!response.ok) return null
    const body = (await response.json()) as Partial<ReferralProgramTerms>
    return {
      referrerMinutes: body.referrerMinutes ?? 0,
      refereePurchaseMinutes: body.refereePurchaseMinutes ?? 0,
      holdbackDays: body.holdbackDays ?? 0,
    }
  } catch {
    // Sin términos no hay promesa numérica: el copy cae al genérico (honesto).
    return null
  }
}
